/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './pagination.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/shared/pagination/pagination.component';
const styles_PaginationComponent:any[] = [i0.styles];
export const RenderType_PaginationComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PaginationComponent,data:{}});
function View_PaginationComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',[['class',
      'pagination__button']],[[2,'pagination__button--active',(null as any)]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.navTo((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = ((<any>_v.parent).context.$implicit === _co.current);
        _ck(_v,0,0,currVal_0);
        const currVal_1:any = (<any>_v.parent).context.$implicit;
        _ck(_v,1,0,currVal_1);
      });
}
function View_PaginationComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',[['class',
      'pagination__button pagination__button--disabled']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['…']))],
      (null as any),(null as any));
}
function View_PaginationComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'li',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PaginationComponent_2)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf'],ngIfElse:[1,'ngIfElse']},(null as any)),(_l()(),i1.ɵand(0,[['ellipsis',
          2]],(null as any),0,(null as any),View_PaginationComponent_3))],(_ck,_v) => {
    const currVal_0:any = (_v.context.$implicit !== (null as any));
    const currVal_1:any = i1.ɵnov(_v,3);
    _ck(_v,2,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_PaginationComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),20,'nav',[['aria-label',
      'Page navigation']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),19,'ul',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(278528,
      (null as any),0,i2.NgClass,[i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),3,'li',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      2,'span',[['class','pagination__button']],[[2,'pagination__button--disabled',
          (null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.PaginationComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.navTo(_co.start)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['«'])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),3,'li',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      2,'span',[['class','pagination__button']],[[2,'pagination__button--disabled',
          (null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.PaginationComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.navTo((_co.current - 1))) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['‹'])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_PaginationComponent_1)),i1.ɵdid(802816,
      (null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
      {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      3,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',[['class',
      'pagination__button']],[[2,'pagination__button--disabled',(null as any)]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i3.PaginationComponent = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.navTo((_co.current + 1))) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,
      'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['›'])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),3,'li',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      2,'span',[['class','pagination__button']],[[2,'pagination__button--disabled',
          (null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.PaginationComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.navTo(_co.end)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['»']))],(_ck,_v) => {
    var _co:i3.PaginationComponent = _v.component;
    const currVal_0:any = _co.classes;
    _ck(_v,2,0,currVal_0);
    const currVal_3:any = _co.truncated;
    _ck(_v,12,0,currVal_3);
  },(_ck,_v) => {
    var _co:i3.PaginationComponent = _v.component;
    const currVal_1:any = (_co.current === _co.start);
    _ck(_v,4,0,currVal_1);
    const currVal_2:any = (_co.current === _co.start);
    _ck(_v,8,0,currVal_2);
    const currVal_4:any = (_co.current === _co.end);
    _ck(_v,14,0,currVal_4);
    const currVal_5:any = (_co.current === _co.end);
    _ck(_v,18,0,currVal_5);
  });
}
export function View_PaginationComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-pagination',
      ([] as any[]),(null as any),(null as any),(null as any),View_PaginationComponent_0,
      RenderType_PaginationComponent)),i1.ɵdid(573440,(null as any),0,i3.PaginationComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const PaginationComponentNgFactory:i1.ComponentFactory<i3.PaginationComponent> = i1.ɵccf('admin-pagination',
    i3.PaginationComponent,View_PaginationComponent_Host_0,{start:'start',end:'end',
        current:'current',color:'color',size:'size'},{page:'page'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/pagination/pagination.component.ngfactory.ts